import React from 'react'

import { withStyles } from '@material-ui/core/styles'

import MenuItem from '@material-ui/core/MenuItem'

const SelectMenuItem = withStyles(({ palette }) => ({
  root: {
    backgroundColor: 'white !important',
    '&:hover': {
      color: palette.common.white,
      backgroundColor: `${palette.trunkrs.secondary.violet.base} !important`,
    },
  },
}))(MenuItem)

export default SelectMenuItem
